import { render, staticRenderFns } from "./home_overseas_light.vue?vue&type=template&id=2f675254&scoped=true&"
import script from "./home_overseas_light.vue?vue&type=script&lang=js&"
export * from "./home_overseas_light.vue?vue&type=script&lang=js&"
import style0 from "./home_overseas_light.vue?vue&type=style&index=0&lang=less&"
import style1 from "./home_overseas_light.vue?vue&type=style&index=1&id=2f675254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f675254",
  null
  
)

export default component.exports